/* eslint-disable linebreak-style */
import React, { useEffect } from 'react';
import copyToClipboard from 'utils/copyToClipboard';
import { useAmp } from 'next/amp';
import Icon from 'base-ui/dist/Icon';
import PropTypes from 'prop-types';

import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { intl } from 'components/LocaleProvider';
import messages from './messages';

const CopyLinkButton = ({ post }) => {
  const { isMobile } = useDeviceScreen();

  useEffect(() => {
    // function animate show and hide tag
    let tagClose = true;

    function animeTag(element, action) {
      const workElement = element.getElementsByClassName('tag-alert-copied')[0];
      if (tagClose) {
        element.classList.add('show-hide-tag');
        setTimeout(() => {
          tagClose = false;
          workElement.classList.remove(action);
          animeTag(element, 'fadeOut');
        }, 1500);
      }
      workElement.classList.add('animated', action);
      if (!tagClose) {
        setTimeout(() => {
          tagClose = true;
          element.classList.remove('show-hide-tag');
          workElement.classList.remove(action);
        }, 500);
      }
    } // end animateTag()
    // listener to share link button
    const targetElement = document.getElementsByClassName('tag-copied-share')[0];
    if (targetElement) {
      targetElement.addEventListener('click', (e) => {
        e.preventDefault();
        animeTag(targetElement, 'fadeIn');
        copyToClipboard(targetElement);
      });
    }
  }, []);

  if (!useAmp()) {
    return (
      <React.Fragment>
        <a
          href="#"
          id="copy-link-shared"
          data-with-google-events="true"
          data-google-events={JSON.stringify({
            data: {
              action: 'copy',
              category: 'Share',
              label: `Copy ${post.link}`
            }
          })}
          className={
            isMobile && post.previous_post
              ? 'tag-copied tag-copied-share titles-bg share-btn white-color'
              : 'tag-copied tag-copied-share titles-bg white-color'
          }
        >
          <Icon className="icon copy-link-shared" prefix="fas" name="link" />
          <span className="tag-alert-copied">
            {intl.formatMessage(messages.copiedLinkAlert)}
            {' '}
          </span>
        </a>
      </React.Fragment>
    );
  }

  return null;
};

CopyLinkButton.propTypes = {
  post: PropTypes.object.isRequired,

};

export default CopyLinkButton;
